var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialMediaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    preserveAspectRatio: "xMidYMid meet",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.60001C16.5 5.45776 13.1422 2.10001 9 2.10001C4.85775 2.10001 1.5 5.45776 1.5 9.60001C1.5 13.7423 4.85775 17.1 9 17.1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97266 6.975L16.0277 6.975M9.75016 2.1375C9.75016 2.1375 12.0002 5.1 12.0002 9.6L9.75016 2.1375ZM8.25016 17.0625C8.25016 17.0625 6.00016 14.1 6.00016 9.6C6.00016 5.1 8.25016 2.1375 8.25016 2.1375L8.25016 17.0625ZM1.97266 12.225L9.00016 12.225L1.97266 12.225Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4094 14.0378C16.7799 14.2658 16.7566 14.82 16.3756 14.8635L14.4504 15.0818L13.5871 16.8158C13.4161 17.16 12.8874 16.9913 12.7996 16.5653L11.8584 11.9783C11.7841 11.6183 12.1081 11.3918 12.4209 11.5845L16.4094 14.0378V14.0378Z",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIcon);
export default __webpack_public_path__ + "static/media/social_media_icon.e6a0ea7a.svg";
export { ForwardRef as ReactComponent };